import { render, staticRenderFns } from "./DeleteWidgetModal.vue?vue&type=template&id=faf3e300"
import script from "./DeleteWidgetModal.vue?vue&type=script&lang=js"
export * from "./DeleteWidgetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faf3e300')) {
      api.createRecord('faf3e300', component.options)
    } else {
      api.reload('faf3e300', component.options)
    }
    module.hot.accept("./DeleteWidgetModal.vue?vue&type=template&id=faf3e300", function () {
      api.rerender('faf3e300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/designer/DeleteWidgetModal.vue"
export default component.exports